export const jsonFormat = (value: unknown) => (value && typeof value === 'object' ? JSON.stringify(value, null, 2) : (value as string) ?? '');

export const jsonParse = (value: string) => {
  try {
    return JSON.parse(value) as unknown;
  } catch {
    return value;
  }
};

export const optionalJsonParse = (value: string) => (value.trim() === '' ? null : jsonParse(value));

const isJsonObject = (value: unknown) => typeof value === 'object' && value !== null && !Array.isArray(value);

const checkJsonObject = (value: unknown): string | undefined => {
  if (isJsonObject(value)) return undefined;
  if (typeof value === 'string') {
    try {
      return isJsonObject(JSON.parse(value)) ? undefined : 'Must be a JSON object';
    } catch {
      return 'Invalid JSON';
    }
  }
  return 'Must be a JSON object';
};

export const validateJsonObject = (value: unknown): string | undefined => (value ? checkJsonObject(value) : 'Required');

export const validateOptionalJsonObject = (value: unknown): string | undefined => (value === null || value === undefined || value === '' ? undefined : checkJsonObject(value));
